module.exports = __webpack_public_path__ + "assets/img/yingte.b371d384.png";